import { render, staticRenderFns } from "./WorkBookTableTotalTopFive.vue?vue&type=template&id=7a9212cb&scoped=true&"
import script from "./WorkBookTableTotalTopFive.vue?vue&type=script&lang=js&"
export * from "./WorkBookTableTotalTopFive.vue?vue&type=script&lang=js&"
import style0 from "./WorkBookTableTotalTopFive.vue?vue&type=style&index=0&id=7a9212cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a9212cb",
  null
  
)

export default component.exports